import {pageInfo, deleteData} from './../api';
import {Message} from 'element-ui';

const xxlJobLog = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    deleteDataObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    DELETE_DATA(state, data) {
      state.deleteDataObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async deleteData({commit}, obj) {
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    }
  }
}
export default xxlJobLog



// WEBPACK FOOTER //
// ./src/page/log/xxlJobLog/store/xxlJobLog.store.js